// extracted by mini-css-extract-plugin
module.exports = {"selectGroup":"SendConsentFormsModal_selectGroup__z8FCp","active":"SendConsentFormsModal_active__Ir1JR","inactive":"SendConsentFormsModal_inactive__1KpA6"};